// removed by extract-text-webpack-plugin
module.exports = {"Col":"Col___3KwLK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Profile/User/Profile.module.scss
// module id = 611
// module chunks = 0